export const setInitiatorName = () => {
  const element = document.querySelector("[data-wm-initiator-name]");

  if (!element) {
    return;
  }

  const initiatorName = element.dataset.wmInitiatorName;

  let text = element.innerHTML.replace("[% inititator_name %]", initiatorName);

  element.innerHTML = text;

  element.classList.remove("invisible");
};
